import React from 'react'
import {Home} from "./components/Home";
import { Navbar } from './components/Navbar';
import { About} from './components/About';
import { Project } from './components/Project';
import { ContactMe } from './components/ContactMe';
import './App.css';
import { Footer } from './components/Footer';

export default function App() {
  return (
   <>
   <div className='Apps'>
    <Navbar />
    <Home />
    <About/>
    <Project/>
    <ContactMe/>
    <Footer />
    </div>
   </>
  )
}
